module.exports = __webpack_public_path__ + "static/curve-analysis-static-6a61434c5bb87463d3e21eb231760828.png";